import { defineMessages } from 'react-intl';

export default defineMessages({
    firstRepayment: {
        id: '_.draw_down.choose_amount.first_repayment',
        defaultMessage: 'First repayment'
    }
});
